module.exports = __webpack_public_path__ + "img/huodong.48cb62f1.png";